export const Grip = [
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/HDGRPSOFTEXBL.jpg",
    title: "Head Softex Badminton Overgrip (Blue)",
    desc: "Head Softex Badminton Overgrip (Blue) ",
    price: "450",
    mrp: "399",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/HDGRPSOFTEXOR.jpg",
    title: "Head Softex Badminton Overgrip (Orange)",
    desc: "Head Softex Badminton Overgrip (Orange) ",
    price: "450",
    mrp: "399",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/HDGRPSOFTEXLM.jpg",
    title: "Head Softex Badminton Overgrip (Lime)",
    desc: "Head Softex Badminton Overgrip (Lime) ",
    price: "450",
    mrp: "399",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/HDGRPPROCSHNL.jpg",
    title: "Head Pro Cushion Badminton Replacement Grip",
    desc: "Head Pro Cushion Badminton Replacement Grip ",
    price: "250",
    mrp: "225",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/HDGRPBLSTRL.jpg",
    title: "Head Bolster Badminton Replacement Grip",
    desc: "Head Bolster Badminton Replacement Grip ",
    price: "146",
    mrp: "125",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/HDBDOVRWRAPSL.jpg",
    title: "Head Badminton Overgrip",
    desc: "Head Badminton Overgrip ",
    price: "94",
    mrp: "80",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/HDGRPCUROL.jpg",
    title: "Head Curo Badminton Overgrip",
    desc: "Head Curo Badminton Overgrip ",
    price: "68",
    mrp: "60",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/HDGRPSOFTEXBK.jpg",
    title: "Head Softex Badminton Overgrip (Black)",
    desc: "Head Softex Badminton Overgrip (Black) ",
    price: "450",
    mrp: "399",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/HDGRPSOFTEXWH.jpg",
    title: "Head Softex Badminton Overgrip (White)",
    desc: "Head Softex Badminton Overgrip (White) ",
    price: "450",
    mrp: "399",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/CTBGR005819.jpg",
    title: "Carlton 701XL PU Badminton Overgrip",
    desc: "Carlton 701XL PU Badminton Overgrip ",
    price: "90",
    mrp: "75",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCGRHC2541N.jpg",
    title: "DSC Hi Soft Cushioned Badminton Grip",
    desc: "DSC Hi Soft Cushioned Badminton Grip ",
    price: "67",
    mrp: "60",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/DSCPROVBDGR.jpg",
    title: "DSC Pro OverGrip",
    desc: " ",
    price: "64",
    mrp: "50",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/YXBDGR9900L.jpg",
    title: "YONEX Aero Cush Replacement Grip",
    desc: "YONEX Aero Cush Replacement grip : These Replacement grips are suited for Tennis and Badminton; Soft Touch & Tacky feel ",
    price: 0,
    mrp: "135",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/YXBDGRETSUP.jpg",
    title: "YONEX Super Textured Over Grip",
    desc: "YONEX Super Over Grip : These overgrips are suited for Tennis and Badminton; Good sweat absorption and Soft Touch ",
    price: 0,
    mrp: "65",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/basicns_l.jpg",
    title: "YONEX BASIC NS GRIP",
    desc: "\nBASIC NS GRIP : For Standard & Long Racquets ;  Available in black ",
    price: "499",
    mrp: "449",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/AC102EX.jpg",
    title: "YONEX SUPER GRAP ( 3 Wraps)",
    desc: "\nSUPER GRAP ( 3 wraps) : Top selling Yonex overgrips! It absorbs shock and perspiration giving you excellent control and feel. ",
    price: "485",
    mrp: "436",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/meshgrap3_1_l.jpg",
    title: "YONEX MESH GRAP ( 3 Wraps )",
    desc: "\nMESH GRAP ( 3 wraps) : Gives excellent Tacky Feel & very Absorbent. Available in colours. For Standard and Long Racquet ",
    price: "875",
    mrp: "740",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/meshgrap3_1_l.jpg",
    title: "YONEX MESH GRAP",
    desc: "MESH GRAP\nExcellent Tacky Feel & Absorbent\nAvailable in many colours ",
    price: "415",
    mrp: "375",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/stronggrap_l.jpg",
    title: "YONEX STRONG GRAP ( 3 Wraps )",
    desc: "STRONG GRAP (3 wraps)\nExcellent Tacky Feel & Durability\nAvailable in many colours ",
    price: "775",
    mrp: "695",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/cleangrap_l.jpg",
    title: "YONEX CLEAN GRAP ( 3 Wraps )",
    desc: "\nCLEAN GRAP (3 wraps) : The new material, 'Odourless', provides anti-bacterial properties and deodorises, supporting hygienic play.  ",
    price: "875",
    mrp: "795",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/YXBDGR7405L.jpg",
    title: "YONEX Acetec Replacement Grip",
    desc: "YONEX Acetec Replacement grip : These Replacement grips are suited for Tennis and Badminton; Soft Touch ",
    price: 0,
    mrp: "125",
    discount: 0,
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/YXBDGPAC153.jpg",
    title: "Yonex Dry Tacky Grap (Pack Of 3)",
    desc: "Your grip tape is as importantÂ as any other part of yourÂ racquet. ",
    price: "1,250",
    mrp: "1,125",
    discount: 0,
  },
];
